import axios from "axios";
import i18n from "@/i18n";
import store from "@/store";
import Cookies from "js-cookie";

const baseURL = (process.env.VUE_APP_API_URL || "http://localhost:8000").replace(/\/$/, "") + "/api";

const api = axios.create({
  baseURL,
  headers: { Accept: "application/json", "Content-Type": "application/json" },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || Cookies.get("token") || store?.getters?.token;
  if (token) config.headers.Authorization = `Bearer ${token}`;

  const tenant = JSON.parse(localStorage.getItem("tenant") || "{}");
  if (tenant && tenant.slug) {
    config.headers["X-Tenant"] = tenant.slug;
  }

  const saved = localStorage.getItem("locale");
  const raw = i18n?.global?.locale?.value || saved || "en";
  const loc = String(raw).split("-")[0] || "en";
  config.headers["Accept-Language"] = loc;
  config.headers["X-Locale"] = loc;

  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      try {
        store?.dispatch?.("logoutUser");
      } catch {
        // ignore
      }
    }

   if (
      e?.response?.status === 402 &&
      e?.response?.data?.code === "SUBSCRIPTION_REQUIRED"
    ) {
      try {
        localStorage.setItem(
          "subscription_block",
          JSON.stringify({
            reason: e.response.data.reason || null,
            subscription: e.response.data.subscription || null,
            at: Date.now(),
          })
        );
      } catch {
        // ignore
      }

      if (
        typeof window !== "undefined" &&
        !window.location.pathname.startsWith("/subscription-required")
      ) {
        window.location.assign("/subscription-required");
      }
    }

    return Promise.reject(e);
  }
);

export default api;